<template>
	<div class="multi-step__controls" :class="{ 'active': active }">
        <Btn label="Label_Previous" @click="lastStep()" :disabled="firststep" />
        <Btn label="Label_Next" @click="nextStep()" :disabled="laststep || nextDisabled" />
        <Btn float="right" label="Label_SaveButton" v-if="laststep" />
    </div>
</template>

<script>
import { Btn } from 'components/layout/forms'

export default {
  name: 'step-controls',
  components: { Btn },
  props: ['step', 'currentstep', 'stepcount', 'nextDisabled'],
  computed: {
    active() {
      return (this.step.id === this.currentstep)
    },
    firststep() {
      return (this.currentstep === 1)
    },
    laststep() {
      return (this.currentstep === this.stepcount)
    }
  },
  methods: {
    nextStep() {
      this.$emit('step-change', this.currentstep + 1)
    },
    lastStep() {
      this.$emit('step-change', this.currentstep - 1)
    }
  }
}
</script>



// WEBPACK FOOTER //
// Controls.vue?02b64b2b